import {SearchTermFilter} from '../search-term.filter';
import {CategoryFilter} from './category.filter';
import {AudienceFilter} from './org.filter';
import {TypeFilter} from './type.filter';
import {FavoriteFilter, OwnerFilter} from './user.filter';
import {VisibilityFilter} from './visibility.filter';

export {ResourceMeComponent} from './me.component';
export const RESOURCE_FILTERS = [
  SearchTermFilter,
  CategoryFilter,
  TypeFilter,
  AudienceFilter,
  OwnerFilter,
  VisibilityFilter,
  FavoriteFilter,
];
